var map = {
	"./arugambay.json": [
		5793,
		793
	],
	"./bir.json": [
		1289,
		289
	],
	"./goa.json": [
		4905,
		905
	],
	"./hiriketiya.json": [
		9583,
		583
	],
	"./varkala.json": [
		9261,
		261
	],
	"./weligama.json": [
		3026,
		26
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9273;
module.exports = webpackAsyncContext;